
import * as types from './types';
import axios from 'axios';

export default {
  /**
   * Ação para criar um novo link compartilhado.
   * @param {object} context - O contexto do Vuex ({ commit }).
   * @param {object} linkConfig - A configuração do link vinda do modal.
   * @returns {Promise}
   */
  async [types.CREATE_LINK]({ commit }, linkConfig) {
    commit(types.SET_LOADING, true);
    commit(types.SET_ERROR, null);
    try {
      const response = await axios.post('share-scale-links', linkConfig);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro ao criar o link.';
      commit(types.SET_ERROR, errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_LOADING, false);
    }
  },

  /**
   * Ação para buscar os links de uma escala.
   * @param {object} context - O contexto do Vuex ({ commit }).
   * @param {string} scaleId - O ID da escala.
   */
  async [types.FETCH_LINKS]({ commit }, scaleId) {
    commit(types.SET_LOADING, true);
    commit(types.SET_ERROR, null);
    try {
      const response = await axios.get(`/api/v1/scales/${scaleId}/shared-links`);
      commit(types.SET_LINKS, response.data);
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro ao buscar os links.';
      commit(types.SET_ERROR, errorMessage);
      commit(types.SET_LINKS, []);
    } finally {
      commit(types.SET_LOADING, false);
    }
  },

  /**
   * Ação para revogar um link.
   * @param {object} context - O contexto do Vuex ({ commit }).
   * @param {string} linkId - O ID do link a ser revogado.
   */
  async [types.REVOKE_LINK]({ commit }, linkId) {
    commit(types.SET_LOADING, true);
    commit(types.SET_ERROR, null);
    try {
      const response = await axios.patch(`share-scale-links/${linkId}/revoke`);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro ao revogar o link.';
      commit(types.SET_ERROR, errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_LOADING, false);
    }
  },


  /**
   * Ação para buscar as informações de um link pelo ID da escala.
   * @param {object} context - O contexto do Vuex ({ commit }).
   * @param {string} scaleId - O ID da escala.
   * @returns {Promise<object>} - As informações do link.
   */
  async [types.FETCH_LINK_BY_SCALE_ID]({ commit }, scaleId) {
    commit(types.SET_LOADING, true);
    commit(types.SET_ERROR, null);
    try {
      const response = await axios.get(`share-scale-links/scale/${scaleId}`);
      return response.data;
    } catch (error) {
       if (error.response && error.response.status === 404) {
        return null;
      }
      const errorMessage = error.response?.data?.message || 'Erro ao buscar informações do link.';
      commit(types.SET_ERROR, errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_LOADING, false);
    }
  },

  /**
   * Ação para atualizar um link existente com todas as suas configurações.
   * @param {object} context - O contexto do Vuex ({ commit }).
   * @param {object} { linkId, config } - O ID do link e o payload com a configuração completa.
   */
  async [types.UPDATE_LINK]({ commit }, { linkId, config }) {
    commit(types.SET_LOADING, true);
    commit(types.SET_ERROR, null);
    try {
      const response = await axios.patch(`share-scale-links/${linkId}`, config);
      commit(types.UPDATE_LINK_IN_LIST, response.data.link);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro ao atualizar o link.';
      commit(types.SET_ERROR, errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_LOADING, false);
    }
  },

  /**
   * Ação para buscar as informações de um link pelo ID do grupo.
   * @param {object} context - O contexto do Vuex ({ commit }).
   * @param {string} groupId - O ID do grupo.
   * @returns {Promise<object>} - As informações do link.
   */
  async [types.FETCH_LINK_BY_GROUP_ID]({ commit }, groupId) {
    commit(types.SET_LOADING, true);
    commit(types.SET_ERROR, null);
    try {
      const response = await axios.get(`share-scale-links/group/${groupId}`);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return null;
      }
      const errorMessage = error.response?.data?.message || 'Erro ao buscar informações do link do grupo.';
      commit(types.SET_ERROR, errorMessage);
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_LOADING, false);
    }
  }
};
